/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Ai_Tools_Studio_Signin_BodyInputs */

const en_directory_ai_tools_studio_signin_body = /** @type {(inputs: Directory_Ai_Tools_Studio_Signin_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Free and takes seconds. Your photos are only used to make your video.`)
};

const zh_directory_ai_tools_studio_signin_body = /** @type {(inputs: Directory_Ai_Tools_Studio_Signin_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`免费，几秒完成。照片只用于生成你的视频。`)
};

/**
* | output |
* | --- |
* | "Free and takes seconds. Your photos are only used to make your video." |
*
* @param {Directory_Ai_Tools_Studio_Signin_BodyInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_ai_tools_studio_signin_body = /** @type {((inputs?: Directory_Ai_Tools_Studio_Signin_BodyInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Ai_Tools_Studio_Signin_BodyInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_ai_tools_studio_signin_body(inputs)
	return zh_directory_ai_tools_studio_signin_body(inputs)
});
export { directory_ai_tools_studio_signin_body as "directory.ai_tools.studio.signin_body" }